<template>
  <CustomModal @close="$emit('close')">
    <template v-slot:body>
      <div class="grid items-center grid-cols-2 col-gap-12 row-gap-12">
        <div class="col-span-2 text-xl font-bold text-text leading-tight mb-4">{{ $t('editGroupTitle') }}</div>
        <BaseInput v-model.trim="group_title"
                   class="col-span-2"
                   :label="$t('inputLabel')">
        </BaseInput>
        <BaseButton @click="updateGroup"
                    :disabled="submitted"
                    theme="gray"
                    class="w-50">
          {{ $t('save') }}
        </BaseButton>
        <ArchiveBtn @confirm="removeGroup"
                    :submitted="submitted"
                    class="ml-auto">
          <template v-slot:text>
            {{ $t('delete') }}
          </template>
        </ArchiveBtn>
      </div>
    </template>
  </CustomModal>
</template>

<script>
import CustomModal from "@/components/UI/modals/CustomModal";
import BaseInput from "@/components/UI/BaseInput/BaseInput";
import BaseButton from "@/components/UI/BaseButton";
import ArchiveBtn from "@/components/UI/ArchiveBtn";
import {mapActions} from "vuex";

export default {
  name: "AccountGroupEditModal",
  components: {ArchiveBtn, BaseButton, BaseInput, CustomModal},
  props: {
    group: {
      type: Object
    }
  },
  data() {
    return {
      group_title: '',
      submitted: false
    }
  },
  methods: {
    ...mapActions('space/accounts', ['updateAccountGroup', 'removeAccountGroup']),
    updateGroup() {
      this.submitted = true;
      this.updateAccountGroup({id: this.group.id, title: this.group_title})
          .then(res => {
            if (res.body.success) {
              this.$emit('close')
              this.$toasted.success('Изменения в группе счетов сохранены');
            } else {
              console.error(res);
            }
          })
    },
    removeGroup() {
      this.submitted = true;
      this.removeAccountGroup({id: this.group.id})
          .then(res => {
            if (res.body.success) {
              this.$emit('close')
              this.$toasted.info('Группа счетов удалена');
            } else {
              console.error(res);
            }
          })
    },
  },
  created() {
    this.group_title = this.group.title;
  },
  beforeDestroy() {
    this.submitted = false
    this.group_title = null;
  },
  i18n: {
    messages: {
      en: {
        editGroupTitle: 'Edit group',
        inputLabel: 'Group name',
        save: 'Save',
        delete: 'Delete group'
      },
      ru: {
        editGroupTitle: 'Редактирование группы',
        inputLabel: 'Название группы',
        save: 'Сохранить',
        delete: 'Удалить группу'
      }
    }
  }
}
</script>